import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { DataItem, connect } from 'scrivito'

import { DocumentFileBox } from './DocumentFileBox'
import { buildDocumentMenuItems } from './menuItems'
import { UnlinkDocumentModal } from '../Modal/UnlinkDocumentModal'
import { DocumentBodyBinary } from '@/Components/Document/types'
import { dataBinaryToUrl } from '@/utils/dataBinaryToUrl'

interface DocumentFileItemProps {
  document: DataItem
  schema: DataItem
  onOpenDrawer: (document: DataItem, startInEditMode: boolean) => void
}

export const DocumentFileItem: React.FC<DocumentFileItemProps> = connect(
  ({ document, onOpenDrawer }) => {
    const { t } = useTranslation()
    const body = document.get('body') as DocumentBodyBinary
    const [url, setUrl] = useState('')
    const displayTitle =
      (document.get('displayTitle') as string) || body.filename || ''

    const isFolder = document.get('folder') as string

    useEffect(() => {
      const fetch = async () => {
        const res = await dataBinaryToUrl(body)
        if (res && res.url) {
          setUrl(res.url)
        }
      }

      if (body) {
        fetch()
      }
    }, [body])

    const [isUnlinkOpen, setIsUnlinkOpen] = useState(false)

    const onOpenDocumentCanvas = () => {
      onOpenDrawer(document, false)
    }

    const onEditDocument = () => {
      onOpenDrawer(document, true)
    }

    const menuItems = buildDocumentMenuItems(t, {
      document,
      downloadUrl: url,
      downloadName: displayTitle,
      onEdit: onEditDocument,
      onUnlink: () => setIsUnlinkOpen(true),
    })

    // do not render broken files
    if (!body && !isFolder) return

    return (
      <li>
        <DocumentFileBox
          key={document.id()}
          documentBody={body}
          document={document}
          onOpenDrawer={onOpenDocumentCanvas}
          title={displayTitle}
          menuItems={menuItems}
        />
        <UnlinkDocumentModal
          isOpen={isUnlinkOpen}
          document={document}
          close={() => setIsUnlinkOpen(false)}
        />
      </li>
    )
  },
)
